Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp,
    colors = _STYLES$useStyles.colors,
    fontBold = _STYLES$useStyles.fontBold,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight;
  var container = {
    width: '100%',
    alignSelf: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: _styles.STYLES.grid.maxColumnWidth
  };
  var title = {
    textAlign: 'center',
    alignSelf: 'center',
    marginBottom: spacing.xxl
  };
  var topSection = {
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
  };
  if (bp.is([bp.mobile_xl, bp.tablet, bp.desktop])) {
    topSection.flexDirection = 'row';
  }
  var filters = {
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: spacing.xl
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    filters.flexDirection = 'row';
  }
  var list = {
    marginTop: spacing.xl
  };
  var pagination = {
    marginTop: spacing.xl
  };
  var createReviewTextContainer = {
    maxWidth: _styles.STYLES.grid.maxInputWidth,
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center'
  };
  var dropdown = {
    alignItems: 'center',
    flexDirection: 'row',
    flex: 1
  };
  if (bp.not([bp.tablet, bp.desktop])) {
    dropdown.flexDirection = 'column';
    dropdown.width = '100%';
  }
  var dropdownSelect = {
    marginBottom: 0,
    flexShrink: 1
  };
  if (bp.not([bp.tablet, bp.desktop])) {
    dropdownSelect.marginTop = spacing.normal;
  }
  var dropdownSelectText = Object.assign({}, fontBold, {
    fontSize: fontSize.normal,
    lineHeight: lineHeight.normal,
    marginRight: spacing.normal,
    color: colors.brand,
    flexShrink: 0
  });
  if (bp.tablet) {
    dropdownSelectText.fontSize = fontSize.s;
    dropdownSelectText.lineHeight = lineHeight.s;
  }
  var editMemberRoleContainer = {
    width: '100%',
    alignItems: 'center'
  };
  var editMemberTeamContainer = {
    marginTop: spacing.xxl,
    width: '100%',
    alignItems: 'center'
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    title: title,
    topSection: topSection,
    filters: filters,
    list: list,
    pagination: pagination,
    createReviewTextContainer: createReviewTextContainer,
    dropdown: dropdown,
    dropdownSelect: dropdownSelect,
    dropdownSelectText: dropdownSelectText,
    editMemberRoleContainer: editMemberRoleContainer,
    editMemberTeamContainer: editMemberTeamContainer
  });
  return {
    styles: styles
  };
};